/** Import modules */

import { useTranslation }       from "react-i18next";

/** Import icons */

import { 
    
    HiChevronRight, 
    
    HiChevronLeft, 
    
    HiChevronDoubleLeft,

    HiChevronDoubleRight }      from "react-icons/hi";

const 

/** Product sorting dataset */

SortingOptions = () => { const

    { t } = useTranslation ();

    return [

        { value: "default", name: t ( "popularity"  ) },

        { value: "DESC",    name: t ( "descending"  ) },

        { value: "ASC",     name: t ( "ascending"   ) }

    ]

},

/** Product catalog pagination */

ProductsPagination = ( pageInfo ) => {

    return [

        { 
            
            icon            : <HiChevronDoubleLeft />, 
            
            query           : { 
                
                f           : 12, 
                
                l           : null, 
                
                a           : null, 
                
                b           : null,

                lp          : null },
            
            state           : ! pageInfo.hasPreviousPage,
        
            disableState    : pageInfo.hasPreviousPage },

        { 
            
            icon            : <HiChevronLeft />, 
            
            query           : { 
                
                l           : 12, 
                
                b           : pageInfo.startCursor, 
                
                a           : null, 
                
                f           : null,

                lp          : null },
            
            state           : ! pageInfo.hasPreviousPage,
        
            disableState    : true },

        { 
            
            icon            : <HiChevronRight />, 
            
            query           : { 
                
                f           : 12, 
                
                a           : pageInfo.endCursor, 
                
                l           : null, 
                
                b           : null,

                lp          : null },
            
            state           : ! pageInfo.hasNextPage,
        
            disableState    : true }

        ,

        {

            icon            : <HiChevronDoubleRight />,

            query           : {

                f           : null,

                l           : 21,

                a           : null,

                b           : null,

                lp          : true

            },

            state           : ! pageInfo.hasNextPage,

            disableState    : pageInfo.hasNextPage

        }

    ];

},

/** Rims catalog pagination */

RimsPagination = ( pageInfo ) => {

    return [

        {
            icon            : <HiChevronDoubleLeft />,
            query           : { f: 21, l: null, a: null, b: null, lp: null },
            state           : ! pageInfo.hasPreviousPage,
            disableState    : pageInfo.hasPreviousPage
        },

        {
            icon            : <HiChevronLeft />,
            query           : { l: 21, b: pageInfo.startCursor, a: null, f: null, lp: null },
            state           : ! pageInfo.hasPreviousPage,
            disableState    : true
        },

        {
            icon            : <HiChevronRight />,
            query           : { f: 21, a: pageInfo.endCursor, l: null, b: null, lp: null },
            state           : ! pageInfo.hasNextPage,
            disableState    : true
        },

        {
            icon            : <HiChevronDoubleRight />,
            query           : { f: null, l: 21, a: null, b: null, lp: true },
            state           : ! pageInfo.hasNextPage,
            disableState    : pageInfo.hasNextPage
        }

    ];

},

/** Batteries catalog pagination */

BatteriesPagination = ( pageInfo ) => {

    return [

        {
            icon            : <HiChevronDoubleLeft />,
            query           : { f: 21, l: null, a: null, b: null, lp: null },
            state           : ! pageInfo.hasPreviousPage,
            disableState    : pageInfo.hasPreviousPage
        },

        {
            icon            : <HiChevronLeft />,
            query           : { l: 21, b: pageInfo.startCursor, a: null, f: null, lp: null },
            state           : ! pageInfo.hasPreviousPage,
            disableState    : true
        },

        {
            icon            : <HiChevronRight />,
            query           : { f: 21, a: pageInfo.endCursor, l: null, b: null, lp: null },
            state           : ! pageInfo.hasNextPage,
            disableState    : true
        },

        {
            icon            : <HiChevronDoubleRight />,
            query           : { f: null, l: 21, a: null, b: null, lp: true },
            state           : ! pageInfo.hasNextPage,
            disableState    : pageInfo.hasNextPage
        }

    ];

};

/** Export datasets */

export { 
    
    SortingOptions, 
    
    ProductsPagination,

    RimsPagination,

    BatteriesPagination

}